import { Avatar, Box, Grid } from '@mui/material';
import DefaultAvatar from 'components/default-avatar';
import { getImageBySize } from 'utils/helpers';

export const EventItemHeader = ({
  avatar,
  initials,
  firstName,
  lastName,
  text,
  date,
}: {
  avatar: string;
  initials: string;
  firstName: string;
  lastName: string;
  text: string;
  date: string;
}) => {
  return (
    <Grid sx={styles.root}>
      <Grid sx={styles.leftBlock}>
        <Grid sx={styles.avatarWrapper}>
          {avatar ? (
            <Avatar
              alt="avatar"
              src={getImageBySize(avatar, 40, 40)}
              sx={styles.avatarImage}
              variant="square"
            />
          ) : (
            <DefaultAvatar
              initials={initials}
              alt="avatar"
              variant="square"
              sx={styles.avatarFallback}
            />
          )}
        </Grid>
        <Grid sx={styles.textContainer}>
          <Box sx={styles.nameRow}>
            <Box component="span">{`${firstName} ${lastName}`}</Box>
            <Box component="span" sx={styles.actionLabel}>
              {text}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box sx={styles.dateLabel}>{date}</Box>
    </Grid>
  );
};

export const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },
  leftBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
    minWidth: 0,
  },
  avatarWrapper: {
    display: 'flex',
    height: 40,
    width: 40,
    position: 'relative',
  },
  avatarImage: {
    width: 40,
    height: 40,
    borderRadius: '8px',
  },
  avatarFallback: {
    borderRadius: '4px',
    width: 40,
    height: 40,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  nameRow: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '122%',
    color: '#23252F',
  },
  actionLabel: {
    fontWeight: 400,
    marginLeft: '4px',
  },
  dateLabel: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '150%',
    color: '#6E707A',
    whiteSpace: 'nowrap',
    marginLeft: 'auto',
  },
};
